import styled, { css } from 'styled-components';

/**
 * The info icon every tooltip in the app hangs off, as one box exactly the
 * size of the icon.
 *
 * Why this exists: the icon used to sit inside a span inside the anchor, so
 * its wrapper was a line of text (about 19px tall at the default font) and
 * the 17px svg sat on that line's baseline via vertical-align: middle, about
 * 1.5px below the line's center. In a row with align-items: center the
 * wrapper got centered, not the icon, so the icon always looked low next to
 * its text, and call sites kept nudging it with mb="2" or mb="3".
 *
 * Now the anchor is block-level (flex, as wide as the icon) with a block svg,
 * so no line of text exists inside it or around it: its box is the icon,
 * 17px, even inside a plain block wrapper (an inline icon in a block wrapper
 * gets a text line of the wrapper's font again, and the same offset). A flex
 * row centers that box on the text exactly - the text box center and the
 * capitals' center coincide for our font.
 *
 * Never nudge it at the call site. If an icon looks off, the row is not
 * centering it (align-items: center, no margins on the icon).
 */
export const InfoAnchor = styled.a<{
  /** Recolors the icon (it is drawn dark gray). */
  $color?: string;
  /** Padding around the icon, which widens what can be hovered. */
  $p?: string;
}>`
  display: flex;
  width: fit-content;
  flex: none;
  align-items: center;
  justify-content: center;
  line-height: 0;
  padding: ${({ $p }) => $p || '0'};

  svg {
    display: block;
  }

  ${({ $color }) =>
    $color &&
    css`
      svg path {
        fill: ${$color};
      }
    `}
`;
